module.exports = __webpack_public_path__ + "img/classic_m2.ce1a4ff0.png";